import { render } from "./createuser_page.vue?vue&type=template&id=31a3dd64&scoped=true"
import script from "./createuser_page.vue?vue&type=script&lang=js"
export * from "./createuser_page.vue?vue&type=script&lang=js"

import "./createuser_page.vue?vue&type=style&index=0&id=31a3dd64&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31a3dd64"]])

export default __exports__